import { render, staticRenderFns } from "./staffSeeParams.vue?vue&type=template&id=742ba046&scoped=true&"
import script from "./staffSeeParams.vue?vue&type=script&lang=js&"
export * from "./staffSeeParams.vue?vue&type=script&lang=js&"
import style0 from "./staffSeeParams.vue?vue&type=style&index=0&id=742ba046&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742ba046",
  null
  
)

export default component.exports